module.exports = __webpack_public_path__ + "img/icon_sec6_01.65b063cf.png";